import {
  useCircleSize,
  Box,
  AHText,
  AHTextFonts,
  StoreFormattedDate,
  ActorAvatar,
} from "arkh";
import React from "react";
import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";
import { TodoListItemCompletedInfo_todo$key } from "./__generated__/TodoListItemCompletedInfo_todo.graphql";

export function TodoListItemCompletedInfo(props: {
  todo: TodoListItemCompletedInfo_todo$key;
}) {
  const smallMedium = useCircleSize("smallMedium");

  const todo = useFragment(
    graphql`
      fragment TodoListItemCompletedInfo_todo on Todo {
        resolvedAtDate {
          ...StoreFormattedDate
        }

        lastChangedStatusByActor {
          ...Avatar_actor
        }
      }
    `,
    props.todo
  );

  return (
    <Box
      style={{
        height: smallMedium,
        alignItems: "center",
        alignContent: "center",
        justifyContent: "center",
        flexDirection: "row",
        flexGrow: 0,
        flexShrink: 1,
      }}
    >
      <AHText
        spaceRight="xsmall"
        color="positive"
        font={AHTextFonts.BOLD}
        type="detail"
      >
        {todo.resolvedAtDate ? (
          <StoreFormattedDate date={todo.resolvedAtDate} />
        ) : null}
      </AHText>
      {todo.lastChangedStatusByActor ? (
        <ActorAvatar actor={todo.lastChangedStatusByActor} size="small" />
      ) : null}
    </Box>
  );
}
